import { ReportsService } from './../../../services/reports.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { InstanceService } from '../../../../../core/src/services/instance.service';
import { AuthService } from 'projects/core/src/services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'or-cleanid-report',
    templateUrl: './cleanid-report.component.html',
    styleUrls: ['./cleanid-report.component.scss'],
    standalone: false
})
export class CleanidReportComponent implements OnInit {

  iframeUrl = '';
  mode = '';
  instanceId = '';
  loading = true;
  @ViewChild('myIframe') public myIframe;

  // TESTING ONLY: switch instances to check QuickSight row-level security. Remove before merging.
  // Only shown with ?showinstanceselector=<key>. The key ships in the JS bundle, so this hides the
  // selector from casual users; it is not access control.
  private readonly instanceSelectorKey = '381fdb3e-b14f-49da-124e-1a91f375b6fa';
  showInstanceSelector = false;
  testInstanceIds: { name: string; id: string }[] = [
    { name: 'OR Instance', id: '339EB389-C219-4E1D-9378-08D7AE29A187' },
    { name: 'Thinq', id: '20B4E1AA-62D1-49A1-B04E-08DB8C5726B3' }
  ];


  constructor(private instanceService: InstanceService, private reportService: ReportsService, public auth: AuthService, private route: ActivatedRoute) {

    this.showInstanceSelector = this.route.snapshot.queryParamMap.get('showinstanceselector') === this.instanceSelectorKey;

    this.route.params.subscribe((params) => {
      this.mode = params.mode;

      if (params.instanceid != null) {
        this.instanceId = params.instanceid;
      }
      this.loadDashboard();
    });
  }
  ngOnInit() {

  }
  onTestInstanceChange(instanceId: string): void {
    this.instanceId = instanceId;
    this.loadDashboard();
  }

  loadDashboard() {
    this.loading = true;
    let source$ = null;

    if(this.mode === "api"){
      source$ = this.reportService.GenerateDefiniteEmbedUrl("api-client-quality", this.instanceId)
    }
    else{
      source$ = this.reportService.GenerateQuicksightEmbedURL("nav-quality", this.instanceId)
    }

    source$.subscribe(data => {
      this.iframeUrl = data;
      const iframe = this.myIframe?.nativeElement;
      if (iframe != null) {
        iframe.src = this.iframeUrl;
      }
      setTimeout(() => this.loading = false, 2500);
    }, _error => {
      this.loading = false;
    });
  }
}
